export enum InteractionType {
  LIKE = "LIKE",
}

export type InteractionRequest = {
  type: InteractionType;
  undo: boolean;
  itemId: string;
};

export type SendWinkRequest = {
  target: string;
};
